module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="hotelReviewContent">\r\n	<div class="hotelReviewUser" itemprop="author">\r\n		<span>'+
((__t=( user ))==null?'':__t)+
'</span>\r\n		<div itemprop="dateCreated" content="'+
((__t=( created.format('YYYY-MM-DD') ))==null?'':__t)+
'" datetime="'+
((__t=( created.format() ))==null?'':__t)+
'"\r\n			 class="hotelReviewDate">'+
((__t=( created.calendar() ))==null?'':__t)+
'</div>\r\n	</div>\r\n	<div itemprop="reviewBody" class="hotelReviewText">'+
((__t=( shortText ))==null?'':__t)+
'</div>\r\n	';
 if(showPreview) { 
__p+='\r\n	<div class="hotelReviewFullText">'+
((__t=( text ))==null?'':__t)+
'</div>\r\n	';
 } 
__p+='\r\n\r\n	';
 if(showPreview) { 
__p+='\r\n	<div class="reviewReadMore show">\r\n		<span>Читать далее</span>\r\n	</div>\r\n	<div class="reviewReadLess"><span>Свернуть</span></div>\r\n	';
 } 
__p+='\r\n</div>\r\n';
 if(Math.floor(rate) != 0) { 
__p+='\r\n<div class="hotelReviewScoreWrapper">\r\n	<div class="overallScore">\r\n		<span itemprop="reviewRating" class="scoreValue r'+
((__t=( Math.floor(rate)))==null?'':__t)+
'">'+
((__t=( rate ))==null?'':__t)+
'<br></span>\r\n		<span class="overallValueMax">из 5</span>\r\n	</div>\r\n	<div class="serviceScoreWrap">\r\n		';
 if(serviceRate > 0) { 
__p+='\r\n		<div class="serviceScore r'+
((__t=( Math.floor(serviceRate) ))==null?'':__t)+
'">\r\n			<div class="scoreTitle">Обслуживание</div>\r\n			<div class="scoreLinesWrapper ">\r\n				';
 _(serviceRate).times(function(){ 
__p+='\r\n				<span class="scoreLine"></span>\r\n				';
 }) 
__p+='\r\n				';
 _(5-serviceRate).times(function(){ 
__p+='\r\n				<span class="scoreLineDefault"></span>\r\n				';
 }) 
__p+='\r\n			</div>\r\n		</div>\r\n		';
 } 
__p+='\r\n		';
 if(locationRate > 0) { 
__p+='\r\n		<div class="locationScore r'+
((__t=( Math.floor(locationRate) ))==null?'':__t)+
'">\r\n			<div class="scoreTitle">Размещение</div>\r\n			<div class="scoreLinesWrapper ">\r\n				';
 _(locationRate).times(function(){ 
__p+='\r\n				<span class="scoreLine"></span>\r\n				';
 }) 
__p+='\r\n				';
 _(5-locationRate).times(function(){ 
__p+='\r\n				<span class="scoreLineDefault"></span>\r\n				';
 }) 
__p+='\r\n			</div>\r\n		</div>\r\n		';
 } 
__p+='\r\n		';
 if(mealRate > 0) { 
__p+='\r\n		<div class="mealScore r'+
((__t=( Math.floor(mealRate) ))==null?'':__t)+
'">\r\n			<div class="scoreTitle">Питание</div>\r\n			<div class="scoreLinesWrapper ">\r\n				';
 _(mealRate).times(function(){ 
__p+='\r\n				<span class="scoreLine"></span>\r\n				';
 }) 
__p+='\r\n				';
 _(5-mealRate).times(function(){ 
__p+='\r\n				<span class="scoreLineDefault"></span>\r\n				';
 }) 
__p+='\r\n			</div>\r\n		</div>\r\n		';
 } 
__p+='\r\n	</div>\r\n\r\n</div>\r\n';
 } 
__p+='';
}
return __p;
};
